"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toParamsString = exports.removeLeadingQueryCharacter = exports.getYoutube = exports.forEachParam = exports.encode = exports.decode = exports.checksArray = void 0;
var _lodash = require("lodash");
const YOUTUBE_REGEX = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
const isString = function () {
  let v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return typeof v === 'string' ? v : String(v);
};
const removeLeadingQueryCharacter = function () {
  let v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(v).charAt(0) === '?' ? v.substr(1) : v;
};
exports.removeLeadingQueryCharacter = removeLeadingQueryCharacter;
const checksArray = name => name && (name.endsWith('.') || name.endsWith('.0') || name.endsWith('%2E0')) ? `${name.replace(/\./g, '%2Elength')}` : name;
exports.checksArray = checksArray;
const decode = name => isString(name).replace(/%2E/g, '.').replace(/length/g, '0').replace(/%21/g, '!').replace(/%3C/g, '<').replace(/%3E/g, '>').replace(/%20/g, ' ').replace(/%5F/g, '_').replace(/%2C/g, ',').replace(/%2B/g, '+').replace(/%40/g, '@');
exports.decode = decode;
const encode = name => isString(name).replace(/[^a-zA-Z0-9 !%_.><=\s+,@]/g, '').replace(/\./g, '%2E').replace(/!/g, '%21').replace(/_/g, '%5F').replace(/</g, '%3C').replace(/>/g, '%3E').replace(/\s/g, '%20').replace(/,/, '%2C').replace(/%2E0/g, '%2Elength');
/**
 * Retrieves default youtube preview thumbnail and embed.
 */

exports.encode = encode;
const getYoutube = function () {
  let url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!isString(url)) throw new Error('URL required');
  const part = (0, _lodash.get)(url.match(YOUTUBE_REGEX), '[2]');
  return part ? {
    thumbnail: `https://img.youtube.com/vi/${part}/0.jpg`,
    embed: `//www.youtube.com/embed/${part}`
  } : {
    thumbnail: null,
    embed: null
  };
};
exports.getYoutube = getYoutube;
const forEachParam = instance => {
  const output = {};
  try {
    // eslint-disable-next-line
    for (const pair of instance.entries()) {
      // eslint-disable-next-line
      output[pair[0]] = pair[1];
    }
  } catch (e) {// noop
  }
  return output;
};
exports.forEachParam = forEachParam;
const toParamsString = paramsInstance => {
  const output = forEachParam(paramsInstance);
  return Object.entries(output).map(_ref => {
    let [key, value] = _ref;
    const left = encodeURIComponent(key);
    return value ? `${left}=${encodeURIComponent(value)}` : left;
  }).join('&');
};
exports.toParamsString = toParamsString;